export default "__VITE_ASSET__5896fa85__"